module.exports = __webpack_public_path__ + "7c0a893e03ada9739087797b564a5748.pdf";